"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Compatible for babel-plugin-import
/* istanbul ignore next */
var _default = exports.default = {};